/* eslint-disable */
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { notification, Button, Modal, Input, Select } from "antd";
import { SmileOutlined } from "@ant-design/icons";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import jwt_decode from "jwt-decode";
import { decryptRequest } from "../../utils/crypt";
import Table from "./UsersTable";
import { getUsersList } from "../../services/User";
import { signUpFetch } from "../../services/Login";
import { FilterForCamera } from "../../services/Filters";
import AlertNotification from "../../common/Alert/AlertNotification";

import "./index.css";

const openNotification = (description) => {
  notification.open({
    message: "Alert",
    description,
    icon: (
      <SmileOutlined
        style={{
          color: "#108ee9",
        }}
      />
    ),
  });
};

function User() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);
  const [usersdata, setUsersData] = useState([]);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [accessValueForNewUser, setAccessValuForNewUser] = useState(null);
  const [newUserName, setNewUserName] = useState("");
  const [newUserEmail, setNewUserEmail] = useState("");
  const [newUserPassword, setNewUserPassword] = useState("");
  const [opendrawer, setOpenDrawer] = useState(false);
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [isActive, setIsActive] = useState(false);
  const [accessValue, setAccessValue] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [addClick, setAddClick] = useState(0);
  const [locations, setLocations] = useState(null);
  const [locationsSelected, setLocationsSelected] = useState(null);
  const [locationType, setLocationType] = useState([
    { label: "Production", value: "Production" },
    { label: "Warehouse", value: "Warehouse" },
  ]);
  const [locationTypeSelected, setLocationTypeSelected] = useState(null);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const authorizedEmails = [
    "Harsh.mishra@assertai.com",
    "Rajesh.roy@assertai.com",
    "shalabh@assertai.com",
  ];

  //Modal Function
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const handleModalClose = () => {
    setIsModalOpen(false);
  };
  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  const showDrawer = () => {
    setOpenDrawer(true);
  };
  const onClose = () => {
    setOpenDrawer(false);
  };

  const usersListFunction = async () => {
    try {
      let params = {};
      let data = await getUsersList();
      if (data?.response?.data?.message === "Token Expired,Login Again.") {
        openNotification("Token Expired,Login Again.");
        navigate("/");
      } else {
        setUsersData(data.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const getFiltersData = async () => {
    let camerasList = await FilterForCamera();
    if (camerasList?.locationNames.length > 0) {
      setLocations(camerasList?.locationNames);
    }
  };

  useEffect(() => {
    try {
      let path = localStorage.getItem("path");
      console.log("Path value of users ", path);
      if (path == "/users") {
        setIsActive(true);
      }
      getFiltersData();
      usersListFunction();
      setAddClick(false);
      let token = localStorage.getItem("token");
      var decoded = jwt_decode(token);
      let { encryptedData } = decoded;
      decryptRequest(encryptedData).then((res) => {
        let { name, email, userType } = JSON.parse(res).data;
        setName(name);
        setEmail(email);
        setAccessValue(userType);
      });
    } catch (error) {
      console.log(error);
    }
  }, []);

  const handleNameChange = (e) => {
    setNewUserName(e.target.value);
  };
  const handleEmailChange = (e) => {
    setNewUserEmail(e.target.value);
  };
  const handlePasswordChange = (e) => {
    setNewUserPassword(e.target.value);
  };

  const handleAccessChange = (value) => {
    setAccessValuForNewUser(value);
  };
  const filterLocationBasedLocationType = async (value) => {
    let camerasList = await FilterForCamera();
    if (camerasList?.locationNames.length > 0) {
      if (value !== "Display All") {
        let filteredLocation = camerasList?.locationNames
          .filter((item) => {
            if (item.type == value) {
              return item;
            }
          })
          .map((item) => {
            return item;
          });
        setLocations(filteredLocation);
      } else {
        getFiltersData();
      }
    }
  };
  const handleLocationTypeChange = (value) => {
    setLocationTypeSelected(value);
    filterLocationBasedLocationType(value);
  };

  const handleLocationsChange = (value) => {
    setLocationsSelected(value);
  };

  function validateEmail(email) {
    const emailRegex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailRegex.test(email);
  }
  function validateName(name) {
    const nameRegex = /^[a-zA-Z\s'-]+$/;
    return nameRegex.test(name);
  }
  const handleAddUser = async (e) => {
    let emailValidation = validateEmail(newUserEmail);
    let nameValidation = validateName(newUserName);
    if (!emailValidation) {
      setError(true);
      setErrorMessage("Enter a valid email");
    } else if (!nameValidation) {
      setError(true);
      setErrorMessage("Enter a valid name");
    } else {
      let data = await signUpFetch({
        newUserName,
        newUserEmail,
        newUserPassword,
        accessValueForNewUser,
        locationTypeSelected,
      });
      if (data.status == false) {
        setError(true);
        setErrorMessage(data?.message);
        setIsModalOpen(false);
      } else if (data) {
        setSuccess(true);
        setSuccessMessage("User created successfully");
        setAddClick(addClick + 1);
        setIsModalOpen(false);
        setNewUserEmail("");
        setNewUserName("");
        setNewUserPassword("");
        setAccessValuForNewUser(null);
        setLocationsSelected(null);
      } else {
        openNotification(data?.message);
        setIsModalOpen(false);
        setNewUserEmail("");
        setNewUserName("");
        setNewUserPassword("");
        setAccessValuForNewUser("");
        setLocationsSelected("");
      }
    }
  };

  const handleSideBar = () => {
    setOpen(!open);
  };

  const handleLogout = () => {
    localStorage.removeItem("Dates");
    localStorage.clear();
    navigate("/");
  };
  const handleNavigate = (path) => {
    localStorage.setItem("path", path);
    navigate(path);
  };

  return (
    <>
      <div
        style={{
          position: "absolute",
          display: "flex",
          justifyContent: "flex-end",
          width: "195vh",
        }}
      >
        {success && (
          <div
            style={{
              width: "40vh",
              height: "5vh",
            }}
          >
            <AlertNotification message={successMessage} status={true} />
          </div>
        )}
        {error && (
          <div
            style={{
              width: "40vh",
              height: "5vh",
            }}
          >
            <AlertNotification message={errorMessage} status={false} />
          </div>
        )}
      </div>
      <div style={{ display: "flex" }} className="my-3 mx-2">
        <div className="UsersMainDiv">
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              cursor: "pointer",
            }}
          >
            <Typography
              textAlign="center"
              style={{
                fontSize: "x-large",
                fontFamily: "Calibri",
                fontStyle: "normal",
                color: "slategray",
              }}
            >
              Users
            </Typography>
          </div>
          <div style={{ display: "flex", gap: "2vh" }}>
            <div>
              <Tooltip
                title={
                  accessValue === "Admin"
                    ? "Click Here To Add The User"
                    : "You Don't Have Permission For Adding User."
                }
              >
                <Button
                  onClick={showModal}
                  disabled={accessValue !== "Admin" && accessValue !== "HSE"}
                  className="bg-teal-700 text-white hover:bg-teal-600"
                >
                  Add User
                </Button>
              </Tooltip>
            </div>
          </div>
          <Table apiData={usersdata} addClick={addClick} />
          <>
            <Modal
              title="Add User"
              open={isModalOpen}
              onOk={handleOk}
              onCancel={handleCancel}
              footer={null}
            >
              <div
                style={{
                  display: "flex",
                  gap: "2vh",
                  flexDirection: "column",
                }}
              >
                <div style={{ padding: "1vh" }}>
                  <Input
                    placeholder="Name"
                    onChange={handleNameChange}
                    value={newUserName}
                  />
                </div>
                <div style={{ padding: "1vh" }}>
                  <Input
                    placeholder="Email"
                    onChange={handleEmailChange}
                    value={newUserEmail}
                  />
                </div>
                <div style={{ padding: "1vh", display: "flex", gap: "2vh" }}>
                  <Select
                    style={{
                      width: 250,
                    }}
                    placeholder="Select user type"
                    value={accessValueForNewUser}
                    onChange={handleAccessChange}
                    options={[
                      { value: "User", label: "User" },
                      { value: "Admin", label: "Admin" },
                      { value: "HSE", label: "HSE" },
                    ]}
                  />
                  <Select
                    style={{
                      width: 250,
                    }}
                    placeholder="Select location type"
                    value={locationTypeSelected}
                    onChange={handleLocationTypeChange}
                    options={[
                      { label: "Production", value: "Production" },
                      { label: "Warehouse", value: "Warehouse" },
                      { label: "Display All", value: "Display All" },
                    ]}
                  />
                </div>
                <div style={{ padding: "1vh" }}>
                  <Input
                    placeholder="Password"
                    type="password"
                    onChange={handlePasswordChange}
                    value={newUserPassword}
                  />
                </div>
                <div style={{ padding: "1vh", gap: "1vh", display: "flex" }}>
                  <Button
                    onClick={handleAddUser}
                    className="bg-teal-700 text-white hover:bg-teal-600"
                  >
                    Submit
                  </Button>
                  <Button
                    onClick={handleModalClose}
                    className="bg-teal-700 text-white hover:bg-teal-600"
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            </Modal>
          </>
        </div>
      </div>
    </>
  );
}

export default User;
